import React from "react";
import { withTranslation } from "react-i18next";
import { PropTypes } from "prop-types";

function ZapierLine({ event_name, email, onChange, zapier, t, enabled }) {
  return (
    <>
      <div className="zapier-cell">
        <span>{t(`zapierEvent.${event_name}`)}</span>
      </div>
      <div className="zapier-cell center">
        <label className="checkbox">
          <input
            onChange={(e) => {
              onChange({ event_name, zapier, email: e.target.checked });
            }}
            checked={email}
            id={event_name}
            name={event_name}
            type="checkbox"
            className="checkbox-input"
          />
          <span className="checkmark" />
        </label>
      </div>
      <div className="zapier-cell">
        {enabled && (
          <span>
            {zapier === 0
              ? t("zapierNotInUse")
              : t("zapierInUse", { count: zapier })}
          </span>
        )}
      </div>
    </>
  );
}

ZapierLine.propTypes = {
  enabled: PropTypes.bool,
  zapier: PropTypes.number,
  email: PropTypes.bool.isRequired,
  event_name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

ZapierLine.defaultProps = {
  inUse: 0,
};

export default withTranslation("editor-platform")(ZapierLine);
